import {Component, inject, Input} from '@angular/core';
import {FormsModule, NgForm} from '@angular/forms';
import {CertificateSelectComponent} from '../../../../shared/commons/certificate-select/certificate-select.component';
import {CertificateSyncButtonComponent} from '../../../../shared/commons/certificate-sync-button/certificate-sync-button.component';
import {CertificateAddButtonComponent} from '../../../../shared/commons/certificate-add-button/certificate-add-button.component';
import {FileUploadComponent} from '../file-upload/file-upload.component';
import {
  SubdistrictAutocompleteComponent
} from '../../../../shared/commons/subdistrict-autocomplete/subdistrict-autocomplete.component';
import {ThaiDateTimePipe} from '../../../../shared/commons/thai-datetime.pipe';
import {FormRegistrationDirective} from '../../../../shared/commons/form-registration.directive';
import {BUSINESS_FORM} from '../business-form.token';
import {AddBusinessFormData} from '../add-business-form-data';

@Component({
  selector: 'app-company-form',
  imports: [
    FormsModule,
    CertificateSelectComponent,
    CertificateSyncButtonComponent, CertificateAddButtonComponent,
    FileUploadComponent,
    SubdistrictAutocompleteComponent,
    ThaiDateTimePipe,
    FormRegistrationDirective
  ],
  templateUrl: './company-form.component.html',
  styleUrl: './company-form.component.scss'
})
export class CompanyFormComponent {
  protected formData: AddBusinessFormData = inject(BUSINESS_FORM);

  @Input() form?: NgForm;
}
